import React, { useEffect } from 'react';
// import { proveedores } from '../../json/proveedores';
import { registro  } from '../../json/registro';
import './registro.css';
import { Link } from 'react-router-dom';

const Registro = () => {  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>Proveedores</h1>
          <hr className='hr-gob'/>
        </div>

     <div className='col-md-12 col-12 ofiprov-card'>
  <img
    src="/assets/imgs/oficina_virtual/Inscrip.Prove..png"
    alt="Inscripción"
    className='ofiprov-img'
  />

  <h2 className='ofiprov-subtitle'>
    Inscripción en el padrón de Proveedores del Estado de Hidalgo
  </h2>

                   <div className='ofiprov-text'>
  <h2 className='ofiprov-subtitle'>
    <strong>AVISO IMPORTANTE</strong>
  </h2>

                  <h2 className='ofiprov-subtitle'>
                    Se informa a las personas físicas y morales interesadas en registrarse
                    que deberán enviar la documentación requerida al correo electrónico
                    padronessc@hidalgo.gob.mx.
                  </h2>

                  <h2 className='ofiprov-subtitle'>
                    Para cualquier consulta, ponemos a su disposición los siguientes medios
                    de contacto en horario laboral, de 8:30 a.m. a 4:30 p.m.:
                  </h2>

                  <h2 className='ofiprov-subtitle'>
                    Correo electrónico: agenda.padron@hidalgo.gob.mx
                  </h2>

                  <h2 className='ofiprov-subtitle'>
                    WhatsApp: 7713625813
                  </h2>

                  <h2 className='ofiprov-subtitle'>
                    Teléfonos: 7717178056 y 7717178057
                  </h2>

                  <h2 className='ofiprov-subtitle'>
                    Agradecemos su atención y comprensión.
                  </h2>
                </div>




                  </div>

      
      </div>
    </div>
  )
}

export default Registro